<template>
  <div class="cell__form-control form-control-yellow">
    <a-input
      v-model="destlocids"
      :placeholder="disabled ? groupTitle : 'Wybierz kierunek'"
      @click="showModal"
      read-only
      :disabled="disabled"
    />
    <a-modal
      :confirmLoading="confirmLoading"
      :visible="visible"
      okText="Wybierz"
      title="Wybierz kierunek/kierunki podróży"
      width="640px"
      wrapClassName="modal-mob"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="dest-select">
        <div class="dest-select__inner">
          <div class="dest-select__list">
            <div
              class="dest-select__list__inner"
              v-for="(region, index) in filteredDests('region')"
              :key="region.rlocid"
            >
              <div class="dest-select__regions">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :value="region.rlocid"
                    :id="region.rlocid"
                    v-bind="{ checked: region.checked }"
                    @change="checkParentRegion(index, $event)"
                    :data-parent="region.parent"
                  />
                  <span class="checkbox-inner"></span>
                  <span class="label-txt strong">{{ region.rname }}</span>
                </label>
                <span
                  class="dest-select__subregions-toggle"
                  @click="region.expanded = !region.expanded"
                >
                  {{ region.expanded ? "Ukryj regiony" : "Pokaż regiony" }}
                </span>
              </div>

              <div v-show="region.expanded" class="dest-select__subregions">
                <template v-for="subregion in filteredDests('subregion')">
                  <div
                    class="d-flex"
                    v-if="subregion.parent == region.parent"
                    :key="subregion.rlocid"
                  >
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        :value="subregion.rlocid"
                        :id="subregion.rlocid"
                        v-bind="{ checked: subregion.checked }"
                        @change="subregion.checked = !subregion.checked"
                        :data-parent="subregion.parent"
                      />
                      <span class="checkbox-inner"></span>
                      <span class="label-txt">{{ subregion.rname }}</span>
                    </label>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../config.js";
axios.defaults.withCredentials = false;

export default {
  props: {
    disabled: Boolean,
    groupTitle: String
  },
  data: () => ({
    urldests: "/getdests.json",
    confirmLoading: false,
    destarr: [],
    destlocids: "",
    destlocidarr: [],
    dests: [],
    regionlist: {},
    visible: false
  }),
  methods: {
    getDests() {
      return axios
        .get(CONFIG.API_URL + this.urldests, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    },
    filteredDests(typ) {
      if (this.dests.length > 0) {
        var bb = this.dests.filter(function(value, index) {
          if (typ == "region") {
            return value.parent == value.rlocid;
          } else if (typ == "subregion") {
            return value.parent != value.rlocid;
          }
        });
        return bb;
      } else {
        return [];
      }
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.confirmLoading = true;
      this.destlocidarr = this.getSelectedRegions;
      this.destlocids = this.filteredLocidNames.join(", ");
      let emitedLocids = this.destlocidarr;
      this.$emit("dataFromDests", emitedLocids);
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 500);
    },
    handleCancel(e) {
      this.visible = false;
    },
    checkParentRegion: function(idx, $event) {
      let filteredRegions = this.filteredDests("region");
      let filteredSubregions = this.filteredDests("subregion");
      let dataParent = $event.target.getAttribute("data-parent");
      filteredRegions[idx].checked = $event.target.checked;

      for (var subIdx in filteredSubregions) {
        let dataParentSubregion = filteredSubregions[subIdx].parent;

        if (dataParentSubregion == dataParent) {
          filteredSubregions[subIdx].checked = $event.target.checked;
        }
      }
    },
    getQueryParamsDests(newParams, addon) {
      let lparams = this.$route.query;
      if (addon) {
        lparams = newParams;
      }
      if (lparams["locid"]) {
        let data = decodeURIComponent(lparams["locid"]);
        let dataArr = data.split(",");
        this.valDests = dataArr;
        this.destarr = dataArr;
        this.destlocidarr = dataArr;
        let list = this.dests;
        let listw = [];
        let parentsChecked = [];
        let _this = this;
        this.regionlist = {};

        list.forEach(function(value, index) {
          if (dataArr.includes(value.rlocid)) {
            _this.regionlist[value.parent] = true;
            value.checked = true;
            listw.push(value.rname);
            parentsChecked.push(value.parent);

            let cil = value.parent;
            let groupParents = list.filter(function(item) {
              return item.parent == cil && item.srlocid == "";
            });
            groupParents[0].expanded = true;
          }
        });
        this.destlocids = listw.join(", ");
      }
    }
  },
  mounted() {
    this.getDests().then(data => {
      //alert('DESTS:' + JSON.stringify(data.page.response));
      this.dests = data.page.response;
      for (var idx in this.dests) {
        this.$set(this.dests[idx], "checked", false);
        this.$set(this.dests[idx], "expanded", false);
      }
      this.getQueryParamsDests(null, false);
    });
    var that = this;
    this.$root.$on("update:locid", val1 => {
      var newquery = Object.assign({}, that.$route.query);
      newquery["locid"] = val1;
      that.getQueryParamsDests(newquery, true);
    });
  },
  computed: {
    filteredLocidNames: function() {
      let _this = this;
      let listw = [];
      let list = this.dests;

      list.forEach(function(value, index) {
        if (_this.destlocidarr.includes(value.rlocid)) {
          listw.push(value.rname);
        }
      });
      return listw;
    },
    getSelectedRegions: function() {
      let filteredRegions = this.filteredDests("region");
      let filteredSubregions = this.filteredDests("subregion");
      var checkedDestsArr = [];

      for (var regIdx in filteredRegions) {
        if (filteredRegions[regIdx].checked) {
          checkedDestsArr.push(filteredRegions[regIdx].rlocid);
        }
      }
      for (var subIdx in filteredSubregions) {
        if (filteredSubregions[subIdx].checked) {
          checkedDestsArr.push(filteredSubregions[subIdx].rlocid);
        }
      }
      return checkedDestsArr;
    }
  }
};
</script>

<style lang="scss" scoped>
.dest-select {
  width: 100%;

  @media (min-width: $screen-sm) {
    height: 320px;
  }

  &__inner {
    overflow: hidden;
    height: 100%;
  }

  &__list {
    height: 100%;
    overflow: auto;

    @media (min-width: $screen-sm) {
      padding-right: 16px;
    }
  }

  &__list-inner {
    display: flex;
    flex-direction: column;
  }

  &__regions {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
  }

  &__subregions {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    padding-left: 26px;
  }

  &__subregions-toggle {
    align-self: center;
    cursor: pointer;
    font-size: 14px;
    color: $blue-light;
    margin-bottom: 6px;
    margin-left: 16px;
    white-space: nowrap;
  }
}
</style>
